import { theme } from '../tailwind';

type StringZIndex = typeof theme.zIndex;
type NumericZIndex = { [K in keyof StringZIndex]: number };

export type ZIndexKey = keyof StringZIndex;

const zIndex = Object.fromEntries(
  Object.entries(theme.zIndex).map(([k, v]) => [k, Number(v)]),
) as NumericZIndex;

export default zIndex;
